<div class="company-list-scroll mb-3">
    <ng-container *ngIf="companies?.length > 0; else noCompaniesTemplate">
        <div
            class="mb-3 p-3 rounded border bg-white shadow-sm company-card"
            [class.company-card--selected]="isSelected(company)"
            *ngFor="let company of companies">

        <div class="company-card-layout">
            <div class="company-check-col" (click)="$event.stopPropagation()">
                <input
                    type="checkbox"
                    class="form-checkbox"
                    [checked]="isSelected(company)"
                    [disabled]="isClosedRegis"
                    (change)="onSelectCompany(company)">
            </div>

            <div class="company-main-col" (click)="!isClosedRegis && onSelectCompany(company)">
                <div class="company-symbol-row">
                    <div class="company-symbol">
                        {{ company.companySymbol || '-' }}<span *ngIf="company.stockExchangeId !== 5 && getExchangeName(company.stockExchangeId)" class="text-muted"> ({{ getExchangeName(company.stockExchangeId) }})</span>
                    </div>
                    <a *ngIf="company.listedJumpplusId" href="https://www.set.or.th/en/market/product/stock/quote/{{company.companySymbol}}/company-profile/jump-plus" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">
                        <img src="assets/images/jumpplus.png" class="jumpplus-icon" alt="JumpPlus">
                    </a>
                    <a href="#" (click)="$event.preventDefault(); $event.stopPropagation(); openCompanyDescription(company);">
                        <img src="/assets/images/book_icon.png" width="16px">
                    </a>
                </div>

                <div class="company-name">{{ company.companyName || '-' }}</div>

                <div class="company-sector">Sector: {{ company.sectorName || '-' }}</div>
                
                <div class="company-slot-row row mx-0">
                    <div class="col-12 col-md-4 px-2 py-2"
                        *ngFor="let slotGroup of getSlotDateGroups(company)">
                        <div class="slot-date-row">
                            <span class="calendar-mini-icon" aria-hidden="true"></span>
                            <span>{{ slotGroup.date | date:'MMM dd, yyyy':timezone }}</span>
                        </div>

                        <div class="slot-time-row" *ngIf="slotGroup.ranges.length > 0">
                            <span class="clock-mini-icon small-offset" aria-hidden="true"></span>
                            <span class="slot-range-list">
                                <span class="slot-range-item" *ngFor="let slotRange of slotGroup.ranges; let i = index">
                                    {{ slotRange }}<span *ngIf="i < slotGroup.ranges.length - 1">&nbsp;|&nbsp;</span>
                                </span>
                            </span>
                        </div>

                        <div class="slot-time-row slot-time-row-virtual" *ngIf="slotGroup.virtualRanges.length > 0">
                            <div class="slot-time-virtual-header">
                                <span class="clock-mini-icon" aria-hidden="true"></span>
                                <span class="virtual-label mr-1 tag-grey">Virtual</span>
                            </div>
                            <span class="slot-range-list slot-range-list-virtual">
                                <span class="slot-range-item" *ngFor="let slotRange of slotGroup.virtualRanges; let i = index">
                                    {{ slotRange }}<span *ngIf="i < slotGroup.virtualRanges.length - 1">&nbsp;|&nbsp;</span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="eventInfoWithConsent?.eventType === eventTypeEnum.THAILANDFOCUS && eventInfoWithConsent?.isSubEvent === false">
                <div class="company-setting-col" [class.company-setting-col--open]="isSelected(company)" (click)="$event.stopPropagation()">
                    <ng-container *ngIf="getSelectedCompanyForm(company) as selectedForm">
                        <div [formGroup]="selectedForm" class="setting-content">
                            <div class="company-name setting-title mb-2">Meeting Type</div>
                            <div class="setting-option-list">
                                <label class="form-check-label setting-option" [class.setting-option--disabled]="attendancePreference === AttendancePreferenceEnum.VIRTUAL">
                                    <input 
                                        type="radio" 
                                        class="form-radio" 
                                        formControlName="meetingType" 
                                        [value]="MeetingTypeEnum.ONEONONE" 
                                        [disabled]="isClosedRegis || attendancePreference === AttendancePreferenceEnum.VIRTUAL"> 
                                        1 on 1
                                </label>
                                <label class="form-check-label setting-option" [class.setting-option--disabled]="attendancePreference === AttendancePreferenceEnum.VIRTUAL">
                                    <input 
                                        type="radio" 
                                        class="form-radio" 
                                        formControlName="meetingType" 
                                        [value]="MeetingTypeEnum.GROUP" 
                                        [disabled]="isClosedRegis || attendancePreference === AttendancePreferenceEnum.VIRTUAL"> 
                                        Group
                                </label>
                                <label class="form-check-label setting-option" [class.setting-option--disabled]="attendancePreference === AttendancePreferenceEnum.PHYSICAL">
                                    <input 
                                        type="radio" 
                                        class="form-radio" 
                                        formControlName="meetingType" 
                                        [value]="MeetingTypeEnum.VIRTUALGROUP" 
                                        [disabled]="isClosedRegis || attendancePreference === AttendancePreferenceEnum.PHYSICAL"> 
                                        Virtual (Group)
                                </label>
                            </div>

                            <div class="company-name setting-title mt-3 mb-2">Priority</div>
                            <div class="setting-option-list">
                                <label class="form-check-label setting-option">
                                    <input 
                                        type="radio" 
                                        class="form-radio" 
                                        formControlName="meetingPriority" 
                                        [disabled]="isClosedRegis"
                                        [value]="MeetingPriorityEnum.HIGH"> 
                                        High
                                </label>
                                <label class="form-check-label setting-option">
                                    <input 
                                        type="radio" 
                                        class="form-radio" 
                                        formControlName="meetingPriority" 
                                        [disabled]="isClosedRegis"
                                        [value]="MeetingPriorityEnum.MEDIUM"> 
                                        Medium
                                </label>
                                <label class="form-check-label setting-option">
                                    <input 
                                        type="radio" 
                                        class="form-radio" 
                                        formControlName="meetingPriority" 
                                        [disabled]="isClosedRegis"
                                        [value]="MeetingPriorityEnum.LOW"> 
                                        Low
                                </label>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div>
        </div>
    </ng-container>

    <ng-template #noCompaniesTemplate>
        <div class="company-empty-state">No available companies.</div>
    </ng-template>
</div>